export default __webpack_public_path__ + "static/media/profile-image.fe34e841.svg";